module.exports = __webpack_public_path__ + "img/no-pic-pc.f208f40b.png";